export interface metaTypes {
  current_page?: number;
  from?: number;
  last_page?: number;
  per_page?: number;
  to?: number;
  total?: number;
  message_templates_last_updated?: string;
  totalItems?: number;
  itemCount?: number;
  targetMessageIndex?: number;
  canShowTemplates?: boolean;
}

export interface DefaultMetaType {
  current_page: number;
  from: number;
  last_page: number;
  per_page: number;
  to: number;
  total: number;
}

export interface infiniteScrollExpose<T> {
  items?: T[];
  loading: boolean;
  isFetching: boolean;
  hasMore: boolean;
  loadNextPage: () => void;
  reset: () => void;
  error?: any;
  meta: DefaultMetaType;
}
export interface TableExpose {
  isEmpty: boolean;
  isLoading: boolean;
  selectedColumnsKeys: string[];
  refreshCurrentPage: () => Promise<void> | void;
  refresh: () => Promise<void> | void;
}
export interface TableDataType<T> {
  meta: metaTypes;
  options: T[];
}

export interface tableColumnType {
  field: string;
  header: string;
  width?: string;
  isRequired?: boolean;
  minWidth?: string;
}

export interface MenuItemsType {
  name: string;
  id: string | number;
  icon?: object | string;
  colorSchema?: string;
}

export interface perPageType {
  name: string | number;
  value: string | number;
}

export enum formModeEnum {
  ADD = 'add',
  EDIT = 'edit',
}

export interface SubsiderItem {
  label: string;
  key: string;
  icon?: string;
  isInjectable?: boolean;
  permission_key?: string;
}

export interface ChildRouteMeta {
  [key: string]: any; // Dynamic key and value pair
}

export interface RouteMeta {
  sideBar?: {
    collapsedToggle?: boolean;
    menuItems: SubsiderItem[];
    meta?: ChildRouteMeta;
  };
  permissions?: {
    type: 'module' | 'sub-module';
    key: string;
  };
  icon?: boolean;
  title?: string;
}

export interface OpenedDropdowns {
  [key: string]: boolean;
}

export enum itemsPerPageEnum {
  TEN = 10,
  TWENTY_FIVE = 25,
  FIFTY = 50,
  ONE_HUNDRED = 100,
}

export interface uiFlagsType {
  isFetching?: boolean;
  isFetchingAnother?: boolean;
  isSubmitting?: boolean;
  isOpen?: boolean;
  isOpenAnother?: boolean;
  isDownloading?: boolean;
  isUpdating?: boolean;
  isDeleting?: boolean;
  isLoading?: boolean;
}
